
const featureImage = {
    label: "Featured Image",
    name: "featured_image",
    widget: "object",
    collapsed: true,
    i18n: true,
    fields: [
        { label: "active", name: "active", widget: "boolean", default: true, required: true, i18n: true, },
        { label: "Page Title active", name: "active_title", widget: "boolean", default: true ,required: false, i18n: true},
        {
            name: "src",
            label: "Image",
            widget: "image",
            required: false,
            media_folder: "/site/assets/images/features/",
            public_folder: "/images/features/",
            i18n: true
        },
        { name: "alt", label: "Alt text", widget: "string", required: false, i18n: true }
    ]
}

export default featureImage;
